<template>
	<el-dialog v-dialogDrag class="im-dialog-shell im-dialog-shell--md" title="添加好友" :visible.sync="dialogVisible" width="560px" :before-close="onClose"
		:close-on-click-modal="false" custom-class="add-friend" @opened="focusSearchInput">
		<el-input ref="searchInput" placeholder="输入账号或手机号搜索好友" class="input-with-select flat-search" v-model="searchText" size="small"
			@keyup.enter.native="onSearch()">
			<i class="el-icon-search el-input__icon" slot="suffix" @click="onSearch()"> </i>
		</el-input>
		<el-scrollbar v-if="showUserList" class="scroll-box">
			<div v-for="(user) in visibleUsers" :key="user.id">
				<div
					class="item"
					:class="{
						'item--quick': quickMode,
						'item--disabled': quickMode && getActionState(user) === 'outgoing'
					}"
					@click="onSelectUser(user)"
				>
					<div class="avatar">
						<head-image :name="user.nickName" :url="user.headImageThumb" :online="user.online"></head-image>
					</div>
					<div class="friend-info">
						<div class="nick-name">
							<div class="nick-name-text">{{ user.userName || user.nickName }}</div>
							<el-tag v-if="user.status == 1" type="danger">已注销</el-tag>
							<el-tag v-if="user.isBanned" type="danger">已封禁</el-tag>
						</div>
						<div class="text-info">
							<div v-if="user.nickName">昵称:{{ user.nickName }}</div>
							<div v-if="lastSearchMode === 'phone' && user.phone">手机号:{{ user.phone }}</div>
						</div>
					</div>
					<template v-if="quickMode">
						<div class="quick-action-tip" :class="`quick-action-tip--${getActionState(user)}`">
							<i v-if="isActionLoading(user.id)" class="el-icon-loading"></i>
							<span v-else>{{ getActionLabel(user) }}</span>
						</div>
					</template>
					<template v-else>
						<el-button v-if="isFriend(user.id)" type="primary" size="mini" icon="el-icon-position"
							@click.stop="onSendMessage(user)">发消息</el-button>
						<span class="status-tip" v-else-if="isWaitingApprove(user.id)">等待对方验证</span>
						<el-button
							type="primary"
							size="mini"
							v-else
							@click.stop="onAddFriend(user)"
							:loading="isActionLoading(user.id)"
							:disabled="Boolean(actionUserId)"
							plain
						>加好友</el-button>
					</template>
				</div>
			</div>
		</el-scrollbar>
		<div v-else class="state-box" :class="{ 'state-box--loading': isSearching }">
			<div class="state-icon">
				<i :class="stateIcon"></i>
			</div>
			<div class="state-title">{{ stateTitle }}</div>
			<div class="state-hint">{{ stateHint }}</div>
			<div v-if="showSearchTips" class="state-chips">
				<span class="state-chip">账号</span>
				<span class="state-chip">手机号</span>
			</div>
		</div>
		<friend-apply ref="applyRef" @close="forceUpdate"></friend-apply>
	</el-dialog>
</template>

<script>
import HeadImage from '../common/HeadImage.vue'
import FriendApply from './FriendApply.vue'

export default {
	name: "addFriend",
	components: { HeadImage, FriendApply },
	data() {
		return {
			users: [],
			searchText: "",
			actionUserId: null,
			isSearching: false,
			lastKeyword: "",
			lastSearchMode: "",
			searchRequestId: 0
		}
	},
	props: {
		dialogVisible: {
			type: Boolean
		},
		quickMode: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		onClose() {
			this.$emit("close");
		},
		resolveSearchMode(keyword) {
			return /^1\d{10}$/.test(String(keyword || '').trim()) ? 'phone' : 'userName';
		},
		resetSearchResult() {
			this.users = [];
			this.lastKeyword = "";
			this.lastSearchMode = "";
			this.isSearching = false;
		},
		async onSearch() {
			const keyword = String(this.searchText || '').trim();
			if (!keyword) {
				this.resetSearchResult();
				return;
			}
			this.searchText = keyword;
			this.lastKeyword = keyword;
			this.lastSearchMode = this.resolveSearchMode(keyword);
			this.isSearching = true;
			const requestId = ++this.searchRequestId;
			try {
				const data = await this.friendStore.searchUsers(keyword);
				if (requestId != this.searchRequestId) {
					return;
				}
				this.users = Array.isArray(data) ? data : [];
				this.users.forEach((u => u.waitApprove = false));
			} finally {
				if (requestId == this.searchRequestId) {
					this.isSearching = false;
				}
			}
		},
		resetDialogState() {
			this.searchText = "";
			this.actionUserId = null;
			this.searchRequestId += 1;
			this.resetSearchResult();
		},
		releaseActionUser(userId = null) {
			if (userId === null || this.actionUserId == userId) {
				this.actionUserId = null;
			}
			this.forceUpdate();
		},
		openApplyDialog(user, options) {
			const applyRef = this.$refs.applyRef;
			if (!applyRef || typeof applyRef.open !== 'function') {
				this.releaseActionUser(user && user.id);
				this.$message.error('好友申请组件未就绪，请稍后重试');
				return false;
			}
			try {
				applyRef.open(user, options);
				return true;
			} catch (error) {
				console.error('打开好友申请失败:', error);
				this.releaseActionUser(user && user.id);
				this.$message.error('好友申请打开失败，请稍后重试');
				return false;
			}
		},
		focusSearchInput() {
			this.$nextTick(() => {
				const searchInput = this.$refs.searchInput;
				if (searchInput && typeof searchInput.focus === 'function') {
					searchInput.focus();
				}
			});
		},
		onSendMessage(user) {
			const friend = this.friendStore.findFriend(user.id) || this.buildFriend(user)
			let chat = {
				type: 'PRIVATE',
				targetId: friend.id,
				showName: friend.showNickName || friend.nickName || friend.userName,
				headImage: friend.headImage,
				userName: friend.userName || ''
			};
			this.chatStore.openChat(chat);
			this.chatStore.setActiveChat(chat);
			this.$router.push("/home/chat");
		},
		onAddFriend(user) {
			if (this.actionUserId || this.isFriend(user.id) || this.isWaitingApprove(user.id)) {
				return;
			}
			this.actionUserId = user.id;
			this.openApplyDialog(user, {
				silent: !user.isManualApprove,
				afterFailure: () => {
					this.releaseActionUser(user.id);
				},
				afterClose: () => {
					this.releaseActionUser(user.id);
				}
			});
		},
		buildFriend(user) {
			return {
				id: user.id,
				nickName: user.nickName,
				showNickName: user.nickName,
				userName: user.userName,
				headImage: user.headImageThumb,
				online: user.online,
				deleted: false
			};
		},
		getIncomingRequest(userId) {
			return this.friendStore.requests.find((request) => request.sendId == userId);
		},
		getActionState(user) {
			if (this.isFriend(user.id)) {
				return 'friend';
			}
			if (this.friendStore.isInRecvRequest(user.id)) {
				return 'outgoing';
			}
			if (this.friendStore.isInSendRequest(user.id)) {
				return 'incoming';
			}
			return 'stranger';
		},
		getActionLabel(user) {
			const state = this.getActionState(user);
			if (state === 'friend') {
				return '发消息';
			}
			if (state === 'outgoing') {
				return '等待验证';
			}
			if (state === 'incoming') {
				return '同意申请';
			}
			return '加好友';
		},
		isActionLoading(userId) {
			return this.actionUserId == userId;
		},
		async onSelectUser(user) {
			if (!this.quickMode) {
				return;
			}
			if (this.actionUserId) {
				return;
			}
			const actionState = this.getActionState(user);
			if (actionState === 'outgoing') {
				return;
			}
			if (actionState === 'friend') {
				this.onSendMessage(user);
				this.onClose();
				return;
			}
			this.actionUserId = user.id;
			if (actionState === 'incoming') {
				await this.onApproveFriendRequest(user);
				return;
			}
			this.openApplyDialog(user, {
				silent: true,
				onSuccess: (request) => {
					if (request.status == this.$enums.REQUEST_STATUS.APPROVED) {
						this.onSendMessage(user);
						this.onClose();
					}
				},
				afterFailure: () => {
					this.releaseActionUser(user.id);
				},
				afterClose: () => {
					this.releaseActionUser(user.id);
				}
			});
		},
		async onApproveFriendRequest(user) {
			const request = this.getIncomingRequest(user.id);
			if (!request) {
				this.actionUserId = null;
				this.forceUpdate();
				return;
			}
			try {
				await this.friendStore.approveFriendRequest(request.id);
				this.friendStore.removeRequest(request.id);
				this.friendStore.addFriend(this.buildFriend(user));
				this.$message.success(`${user.nickName} 已成为您的好友`);
				this.onSendMessage(user);
				this.onClose();
			} finally {
				this.actionUserId = null;
				this.forceUpdate();
			}
		},
		isFriend(userId) {
			return this.friendStore.isFriend(userId);
		},
		isWaitingApprove(userId) {
			return this.friendStore.isInRecvRequest(userId);
		},
		forceUpdate() {
			// 当好友添加成功或申请发送后，强制更新视图以刷新按钮状态
			this.$nextTick(() => this.$forceUpdate());
		}
	},
	computed: {
		currentUserId() {
			return this.userStore && this.userStore.userInfo ? this.userStore.userInfo.id : null;
		},
		visibleUsers() {
			return this.users.filter((user) => user && user.id != this.currentUserId);
		},
		showUserList() {
			return this.visibleUsers.length > 0;
		},
		showInitialState() {
			return !this.isSearching && !this.showUserList && !this.lastKeyword;
		},
		showSelfOnlyState() {
			return !this.isSearching && this.lastKeyword && this.users.length > 0 && this.visibleUsers.length === 0;
		},
		showSearchTips() {
			return this.showInitialState;
		},
		stateIcon() {
			if (this.isSearching) {
				return 'el-icon-loading';
			}
			if (this.showSelfOnlyState) {
				return 'el-icon-user';
			}
			if (this.lastKeyword) {
				return 'el-icon-search';
			}
			return this.quickMode ? 'el-icon-user-solid' : 'el-icon-plus';
		},
		stateTitle() {
			if (this.isSearching) {
				return '正在搜索联系人';
			}
			if (this.showSelfOnlyState) {
				return '搜索结果仅包含当前账号';
			}
			if (this.lastKeyword) {
				return `未找到“${this.lastKeyword}”`;
			}
			return this.quickMode ? '快捷添加联系人' : '搜索并添加好友';
		},
		stateHint() {
			if (this.isSearching) {
				return '正在精确匹配账号信息，请稍候。';
			}
			if (this.showSelfOnlyState) {
				return '当前账号不能添加自己，可尝试搜索对方账号或手机号。';
			}
			if (this.lastKeyword) {
				return '仅支持通过账号或手机号精确搜索，请确认输入是否完整。';
			}
			return this.quickMode
				? '输入账号或手机号后回车，可直接发起好友申请或继续聊天。'
				: '仅支持通过账号或手机号精确搜索联系人。';
		}
	},
	watch: {
		dialogVisible(newVal) {
			if (newVal) {
				this.resetDialogState();
				this.focusSearchInput();
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.add-friend {
	:deep(.el-dialog) {
		width: min(560px, calc(100vw - 24px)) !important;
		border-radius: 12px;
		overflow: hidden;
	}

	:deep(.el-dialog__body) {
		padding: 16px 18px 18px;
	}

	.flat-search {
		margin-bottom: 12px;

		:deep(.el-input__inner) {
			height: 38px;
			line-height: 38px;
			border-radius: 8px;
			border: 1px solid rgba(var(--im-black-rgb), 0.08);
			background: rgba(var(--im-black-rgb), 0.02);
		}
	}

	.scroll-box,
	.state-box {
		height: min(360px, calc(100vh - 252px));
	}

	.scroll-box {
		.item {
			min-height: 60px;
			display: flex;
			position: relative;
			padding: 10px 6px;
			align-items: center;
			border-bottom: 1px solid rgba(var(--im-black-rgb), 0.06);
			transition: background-color 0.2s ease;
			gap: 10px;

			&:hover {
				background: rgba(var(--im-black-rgb), 0.02);
			}

			&.item--quick {
				cursor: pointer;
			}

			&.item--disabled {
				cursor: default;
			}

			.avatar {
				flex-shrink: 0;
			}

			.friend-info {
				margin: 0;
				flex: 1;
				display: flex;
				flex-direction: column;
				overflow: hidden;
				gap: 2px;

				.nick-name {
					display: flex;
					align-items: center;
					gap: 6px;
					min-width: 0;
					white-space: nowrap;

					.nick-name-text {
						min-width: 0;
						font-size: 14px;
						line-height: 22px;
						font-weight: 600;
						color: var(--im-text-color);
						overflow: hidden;
						text-overflow: ellipsis;
					}
				}

				.text-info {
					display: flex;
					flex-direction: row;
					font-size: 12px;
					line-height: 18px;
					white-space: nowrap;
					color: var(--im-text-color-light);
				}
			}

			.status-tip {
				color: var(--im-text-color-light);
				font-size: 12px;
				min-width: 72px;
				text-align: right;
				flex-shrink: 0;
			}

			.quick-action-tip {
				display: inline-flex;
				align-items: center;
				justify-content: center;
				min-width: 78px;
				color: var(--im-text-color-light);
				font-size: 12px;
				line-height: 1;
				flex-shrink: 0;
				text-align: right;

				&--friend,
				&--incoming,
				&--stranger {
					color: var(--im-color-primary);
				}
			}

			:deep(.el-button--mini) {
				min-width: 68px;
				height: 30px;
				padding: 0 12px;
				border-radius: 7px;
			}
		}
	}

	.state-box {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 8px;
		padding: 18px 16px 24px;
		text-align: center;
		color: var(--im-text-color-light);

		&--loading {
			.state-icon i {
				animation-duration: 0.9s;
			}
		}
	}

	.state-icon {
		width: 52px;
		height: 52px;
		border-radius: 16px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		background: rgba(var(--im-primary-rgb), 0.08);
		color: var(--im-color-primary);

		i {
			font-size: 22px;
			line-height: 1;
		}
	}

	.state-title {
		font-size: 15px;
		line-height: 22px;
		font-weight: 600;
		color: var(--im-text-color);
	}

	.state-hint {
		max-width: 320px;
		font-size: 12px;
		line-height: 18px;
		color: var(--im-text-color-light);
	}

	.state-chips {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		gap: 8px;
		margin-top: 2px;
	}

	.state-chip {
		padding: 5px 10px;
		border-radius: 999px;
		background: rgba(var(--im-black-rgb), 0.04);
		color: var(--im-text-color-light);
		font-size: 12px;
		line-height: 1;
	}

	@media (max-width: 640px) {
		:deep(.el-dialog__body) {
			padding: 14px 14px 16px;
		}

		.scroll-box,
		.state-box {
			height: min(340px, calc(100vh - 224px));
		}

		.scroll-box {
			.item {
				padding: 10px 2px;
				gap: 8px;
			}
		}
	}
}
</style>
